<template>
  <div>
    <div class="content">
      <div class="page-header">
        <common-header :data="['home', 'manage', 'jobs']">
          <div>
            <a
              v-if="hasAccess({ permissions: [BASE_PERMISSION.CREATE] })"
              class="btn btn-cp"
              href="#"
              role="button"
              data-toggle="modal"
              data-target="#modal"
              data-backdrop="static"
              data-keyboard="false"
            >
              <i class="fa fa-plus" aria-hidden="true"></i>Add Category</a
            >
          </div>
        </common-header>
      </div>
      <div class="container-fluid">
        <div v-if="hasAccess({ permissions: [BASE_PERMISSION.MENU] })">
          <category-list-element
            v-for="(category, index) in categoriesWithJobs"
            :key="category.id"
            :category="category"
            :is-opened="index === 0"
          ></category-list-element>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content m-t100">
          <div class="modal-header">
            <h3 class="modal-title" id="myModalLabel">Category Details</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="resetValidations($v)"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="content-form">
              <div class="form-group position-relative">
                <label class="control-label"
                  >Category <span class="text-danger"> *</span></label
                >
                <input
                  type="text"
                  name="category-name"
                  v-validate="'required|alpha_spaces|max:30'"
                  data-vv-as="Category Name"
                  data-vv-validate-on="blur|input"
                  class="form-control"
                  v-model="data.category_name"
                  :class="{ invalid: errors.first('category-name') }"
                />
                <span
                  v-if="errors.first('category-name')"
                  class="valid-feedback alert-danger"
                  >{{ errors.first("category-name") }}</span
                >
              </div>
              <div class="form-group position-relative">
                <label class="control-label"
                  >Category Description
                  <span class="text-danger"> *</span></label
                >
                <input
                  type="text"
                  name="category-description"
                  v-validate="'required'"
                  data-vv-as="Category Description"
                  data-vv-validate-on="blur|input"
                  class="form-control"
                  v-model="data.category_description"
                  :class="{ invalid: errors.first('category-description') }"
                />
                <span
                  v-if="errors.first('category-description')"
                  class="valid-feedback alert-danger"
                  >{{ errors.first("category-description") }}</span
                >
              </div>
            </form>
          </div>
          <div class="modal-footer text-center">
            <button
              :disabled="$v.data.$invalid"
              type="button"
              class="btn btn-cp"
              @click="
                addCategory();
                resetValidations($v);
              "
              data-dismiss="modal"
            >
              Create
            </button>
          </div>
        </div>
      </div>
    </div>

    <add-job-modal></add-job-modal>
    <delete-modal></delete-modal>
    <edit-job-modal></edit-job-modal>
    <edit-category-modal></edit-category-modal>
    <open-positions-modal></open-positions-modal>
  </div>
</template>

<script>
import CategoryListElement from "./category-list-element.vue";
import AddJobModal from "./add-job-modal.vue";
import DeleteModal from "./delete-modal.vue";
import EditJobModal from "./edit-job-modal.vue";
import openPositionsModal from "./open-positions-modal.vue";
import EditCategoryModal from "./edit-category-modal.vue";
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import { hasAccess } from "../../User/_utils/actions";
import PERMISSIONS from "../../Common/permissions";

/**
 * @memberof module:ManageJob
 * @namespace components.home
 */
export default {
  /**
   * @memberof module:ManageJob.components.home
   * @returns {Object} data object
   * @description data - returns data for current vue component
   */
  data() {
    return {
      data: {
        category_name: "",
        category_description: "",
        status: "active",
      },
    };
  },

  /**
   * @memberof module:ManageJob.components.home
   * @returns {Object} validation object
   * @description data - returns validation object for current vue component
   */
  validations() {
    const data = {
      category_name: {
        required,
        maxLength: maxLength(30),
        categoryNameValidator: this.categoryNameValidator,
      },
      category_description: {
        required,
      },
    };
    return {
      data,
    };
  },
  components: {
    CategoryListElement,
    AddJobModal,
    DeleteModal,
    EditJobModal,
    EditCategoryModal,
    openPositionsModal,
  },
  methods: {
    hasAccess({ permissions, checkAll }) {
      return hasAccess({ permissions, checkAll });
    },
    /**
     * @memberof module:ManageJob.components.home
     * @param {Object} v object of validation
     * @description method - handle to reset validations
     */
    resetValidations(v) {
      v.$reset();
    },

    /**
     * @memberof module:ManageJob.components.home
     * @description method - dispatch request to add category
     */
    addCategory() {
      this.$store.dispatch("$_manage_jobs/addCategory", this.data);
      this.data = this.resetData();
      $("#modal").modal("hide");
      $(".modal-backdrop").hide();
    },

    /**
     * @memberof module:ManageJob.components.home
     * @param {Object} value input value of job category field
     * @returns {Boolean} validated result
     * @description method - checks whether category name is valid or not
     */
    categoryNameValidator(value) {
      return /^[^-\s][a-zA-Z ]*$/.test(value);
    },

    /**
     * @memberof module:ManageJob.components.home
     * @returns {Object} reset data object
     * @description method - reset data when modal closed
     */
    resetData() {
      return {
        category_name: "",
        category_description: "",
        status: "active",
      };
    },
    getJobs() {
      if (!this.hasAccess({ permissions: [this.BASE_PERMISSION.MENU] })) return;
      this.$store.dispatch("$_manage_jobs/fetchCategoriesWithJobs");
    },
  },
  computed: {
    PERMISSIONS() {
      return PERMISSIONS;
    },
    BASE_PERMISSION() {
      return this.PERMISSIONS.JOB;
    },
    ...mapGetters({
      categoriesWithJobs: "$_manage_jobs/categoriesWithJobs",
    }),
  },

  /**
   * @memberof module:ManageJob.components.home
   * @description lifecycle method - dispatch request of fetching data of job categories and jobs
   */
  created() {
    this.getJobs();
  },

  /**
   * @memberof module:ManageJob.components.home
   * @description lifecycle method - handle data when modal closed
   */
  mounted() {
    $("#modal").on("hidden.bs.modal", () => {
      this.data = this.resetData();
    });
  },
  beforeDestroy() {
    $("#modal").modal("hide");
    $(".modal-backdrop").hide();
    $("body").removeClass("modal-open");
  },
};
</script>

<style scoped>
.container {
  max-width: 100%;
  padding: 10px 35px;
}

@media (max-width: 576px) {
  .container {
    padding: 10px 30px !important;
  }
}
</style>
